import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")<{ $scrolled: boolean }>`
  padding: ${({ $scrolled }) => ($scrolled ? '0.6rem 0' : '1.25rem 0')};
  background-color: ${({ $scrolled }) => $scrolled ? 'rgba(255, 255, 255, 0.92)' : 'transparent'};
  backdrop-filter: ${({ $scrolled }) => $scrolled ? 'blur(10px)' : 'none'};
  box-shadow: ${({ $scrolled }) => $scrolled ? '0 1px 0 var(--line)' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  transition: background-color 0.3s ease, box-shadow 0.3s ease, padding 0.3s ease;

  .ant-row-space-between {
    align-items: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const Burger = styled.div`
  display: none;
  cursor: pointer;

  @media only screen and (max-width: 768px) {
    display: block;
  }

  svg {
    font-size: 1.5rem;
    fill: var(--text-primary);
  }
`;

export const NotHidden = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const CustomNavLinkSmall = styled.a<{ $isActive?: boolean }>`
  font-size: 1rem;
  color: ${(p) => (p.$isActive ? "var(--accent-primary)" : "var(--text-secondary)")};
  transition: all 0.3s ease;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: ${(p) => (p.$isActive ? "600" : "500")};
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%) scaleX(${(p) => (p.$isActive ? "1" : "0")});
    width: 40%;
    height: 2px;
    background: var(--signal);
    transition: transform 0.3s ease;
  }

  &:hover {
    color: var(--accent-primary);
  }
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const LanguageSelector = styled.div`
  margin-left: 1rem;

  .ant-select {
    min-width: 70px;
  }

  .ant-select-selector {
    background-color: transparent !important;
    border: 1.5px solid var(--border-color) !important;
    color: var(--text-primary) !important;
    border-radius: 4px !important;
    transition: all 0.3s ease !important;
    font-weight: 500 !important;

    &:hover {
      border-color: var(--accent-primary) !important;
    }
  }

  .ant-select-arrow {
    color: var(--text-secondary);
  }

  .ant-select-focused .ant-select-selector {
    border-color: var(--accent-primary) !important;
    box-shadow: 0 0 0 2px rgba(220, 101, 57, 0.18) !important;
  }
`;
